import { defineMigrations } from "@tldraw/store";
import { T } from "@tldraw/validate";
import { handleValidator } from "../misc/TLHandle.mjs";
import { StyleProp } from "../styles/StyleProp.mjs";
import { DefaultColorStyle } from "../styles/TLColorStyle.mjs";
import { DefaultDashStyle } from "../styles/TLDashStyle.mjs";
import { DefaultSizeStyle } from "../styles/TLSizeStyle.mjs";
const LineShapeSplineStyle = StyleProp.defineEnum("tldraw:spline", {
  defaultValue: "line",
  values: ["cubic", "line"]
});
const lineShapeProps = {
  color: DefaultColorStyle,
  dash: DefaultDashStyle,
  size: DefaultSizeStyle,
  spline: LineShapeSplineStyle,
  handles: T.dict(T.string, handleValidator)
};
const lineShapeMigrations = defineMigrations({});
export {
  LineShapeSplineStyle,
  lineShapeMigrations,
  lineShapeProps
};
//# sourceMappingURL=TLLineShape.mjs.map
